import { type FC } from 'react';

import { FrontCardView } from '@/components/ui/FrontCardView/FrontCardView';

interface ContractTermsPlugProps {
  cardsCount: number;
  className?: string;
}

const ContractTermsPlug: FC<ContractTermsPlugProps> = ({ cardsCount }) => {
  return Array.from({ length: cardsCount }).map((_, index) => (
    <FrontCardView variant="default" size="small" key={index} />
  ));
};

export { ContractTermsPlug };
